import PropTypes from "prop-types"
import React from "react"

import { useTracker } from "src/hooks/use_tracker"

const CreateAccountCard = ({ copy, createAccountUrl, marina, quoteId }) => {
  const tracker = useTracker()

  const handleCreateAccount = () => {
    tracker.trackEvent("contracts_v2:create_account_pressed", {
      contract_quote_id: quoteId,
      marina_id: marina.id,
      marina_name: marina.name,
    })
  }

  return (
    <div className="rounded-lg border border-gray-300 bg-white p-6">
      <h2 className="m-0 text-2xl font-bold text-gray-900">{copy.title}</h2>
      <p className="mb-6 mt-2 text-gray-700">{copy.subtitle}</p>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {copy.benefits.map((benefit) => (
          <div key={benefit.title} className="flex items-center gap-3">
            <i className={`${benefit.icon} fa-fw fa-lg text-teal-600`} />
            <div className="flex flex-col">
              <span className="font-semibold text-gray-900">
                {benefit.title}
              </span>
              <span className="text-sm text-gray-700">
                {benefit.description}
              </span>
            </div>
          </div>
        ))}
      </div>
      <a
        className="btn btn-primary mt-6 w-full"
        href={createAccountUrl}
        onClick={handleCreateAccount}
      >
        {copy.cta}
      </a>
      <p className="mb-0 mt-2 text-center text-sm text-gray-700">{copy.note}</p>
    </div>
  )
}

export const accountBenefitPropType = PropTypes.shape({
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
})

CreateAccountCard.propTypes = {
  copy: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    note: PropTypes.string.isRequired,
    benefits: PropTypes.arrayOf(accountBenefitPropType).isRequired,
  }).isRequired,
  createAccountUrl: PropTypes.string.isRequired,
  marina: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  quoteId: PropTypes.string.isRequired,
}

export default CreateAccountCard
